/* eslint-disable */

import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { Size } from "../../logic/enums.ts";
import Sparkle from "../raindrop-sparkle/raindrop-sparkle.tsx";

export enum ButtonStyle {
  Primary,
  Secondary,
  Tertiary,
  Outline,
  Destructive,
  Icon,
}

const RaindropButton = ({
  title = "Button",
  icon = "",
  to = "#",
  onClick = (e) => {},
  target = "",
  rel = "",
  style = ButtonStyle.Secondary,
  highlightIcon = false,
  size = Size.Medium,
  isDisabled = false,
  isFluid = false,
  isLoading = false,
  isUnderConstruction = false,
  isHidingTitle = false,
  isDangerous = false,
  isLeftAligned = false,
  isRounded = false,
  isSparkly = true,
}) => {
  let navigate = useNavigate();

  // Particles -- START
  const [particlesShowing, setParticlesShowing] = useState(false);

  useEffect(() => {
    if (!isSparkly) {
      return;
    }
    if (!particlesShowing) {
      return;
    }
    const timer = setTimeout(() => {
      setParticlesShowing(false);
    }, 750);
    return () => clearTimeout(timer);
  }, [particlesShowing]);
  // Particles -- END

  let backgroundColor =
    "bg-color-background-tertiary dark:bg-color-dark-background-tertiary";

  let border = "border-0";
  let borderColor =
    "border-color-border-primary dark:border-color-dark-border-primary";
  let hoverBackgroundColor =
    "md:hover:bg-color-background-tertiary dark:md:hover:bg-color-dark-background-tertiary";
  let iconTextColor =
    "text-color-text-primary dark:text-color-dark-text-primary";
  let opacity = "opacity-100";
  let padding = "py-1 px-4";
  let rounded = "rounded-xl";
  let textSize = "text-md";
  let textColor = "text-color-text-secondary dark:text-color-dark-text-primary";

  let visibility = "visible";
  let width = "w-fit";
  let justifyContent = "justify-center";
  let font = "font-semibold";
  let gap = "gap-2";
  let capitalisationClass = "";
  let hoverTextColor = "";

  switch (size) {
    case Size.Small:
      textSize = "text-sm";
      padding = "px-2 py-1";
      gap = "gap-1";
      break;
    case Size.Large:
      textSize = "text-xl";
      padding = "px-8 py-3";
      break;
  }

  switch (style) {
    case ButtonStyle.Primary:
      backgroundColor = "bg-color-raindrop-primary";
      textColor = "text-color-dark-raindrop-secondary";
      iconTextColor = "text-color-dark-raindrop-secondary";
      hoverBackgroundColor =
        "hover:bg-color-raindrop-primary-hover hover:dark:bg-color-dark-raindrop-primary-hover";
      break;
    case ButtonStyle.Secondary:
      break;
    case ButtonStyle.Tertiary:
      backgroundColor = "transparent";
      iconTextColor = "text-color-text-secondary";
      borderColor = "border-color-raindrop-minor";
      textColor =
        "text-color-text-secondary dark:text-color-dark-text-secondary dark:hover:text-color-raindrop-primary";
      capitalisationClass = "uppercase";
      textSize = "text-sm";
      padding = "px-2 py-1";
      hoverBackgroundColor = "";
      border = "border-0";
      break;

    case ButtonStyle.Outline:
      borderColor =
        "border-color-raindrop-primary dark:border-color-dark-text-primary";
      border = "dark:border-2 border-2";
      textColor =
        "text-color-raindrop-primary dark:text-color-dark-text-primary";
      iconTextColor = "text-color-raindrop-primary";
      backgroundColor = "bg-transparent";
      break;
    case ButtonStyle.Destructive:
      border = "border";
      borderColor = "border-color-status-bad";
      textColor = "text-color-status-bad";
      iconTextColor = "text-color-status-bad";
      backgroundColor = "bg-color-status-bad bg-opacity-10";
      break;
    case ButtonStyle.Icon:
      isHidingTitle = true;
      textSize = "text-xl";
      backgroundColor = "bg-transparent";
      border = "border-0";
      break;
  }

  if (isLeftAligned) {
    justifyContent = "justify-left";
  }

  if (isDisabled) {
    opacity = "opacity-50";
  }

  if (isFluid) {
    width = "w-full";
  }

  if (isLoading) {
    visibility = "invisible";
  }

  if (isUnderConstruction) {
    opacity = "opacity-50";
    icon = "fa-wrench";
  }

  if (isDangerous) {
    border = "border";
    borderColor = "border-color-status-bad";
    textColor = "text-color-status-bad";
  }

  if (isRounded) {
    rounded = "rounded-full";
  }

  if (highlightIcon) {
    iconTextColor = "text-color-raindrop-primary";
  }

  if (to !== "#") {
    onClick = () => {
      if (to.startsWith("http")) {
        window.location.href = to;
        return;
      } else if (to.startsWith("mailto")) {
        window.location.href = to;
        return;
      } else {
        navigate(to);
      }
    };
  }

  const internalOnClick = (e) => {
    if (isLoading) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (isSparkly) {
      setParticlesShowing(true);
    }
    onClick(e);
  };

  return (
    <button
      onClick={internalOnClick}
      className={`flex flex-row transition-all appearance-none ${justifyContent} items-center justify-center ${font} ${gap} whitespace-nowrap md:hover:scale-95 ${width}  ${opacity} ${textColor} ${border} ${borderColor} ${backgroundColor} ${rounded} ${padding} ${hoverBackgroundColor}  md:active:scale-[0.80] relative `}
      target={target}
      rel={rel}
      disabled={isDisabled}
    >
      {icon && (
        <i
          className={`fas ${icon} w-5 text-center ${textColor} ${textSize} ${iconTextColor} `}
        />
      )}

      {!isHidingTitle && title && (
        <div
          className={`${textColor} ${textSize} ${visibility} ${capitalisationClass} font-black ${hoverTextColor}`}
        >
          {title}
        </div>
      )}

      {isLoading && (
        <div className={"flex justify-center items-center absolute"}>
          <div
            className={
              "animate-spin rounded-full w-4 h-4  border-b-4 border-white"
            }
          ></div>
        </div>
      )}

      {particlesShowing && <Sparkle />}
    </button>
  );
};

export default RaindropButton;
